import { UserProfile } from "../../../model";
import { map, Observable } from "rxjs";
import { apiService } from "../../ApiService";

export const resetPinCode = (): Observable<UserProfile> => {
  return apiService
    .post<{ profile: UserProfile }>({
      path: `v1/family/reset_pin`,
      body: {
        tokenType: "family",
      },
      requiresAuthPolicy: "family",
    })
    .pipe(map(({ profile }) => profile));
};
